<template>
  <v-dialog 
    v-model="showDialog" 
    max-width="800px"
    @click:outside="cancel"
  >

    <v-card>
      <!-- Título de la tarjeta -->
      <v-card-title>
        <span class="headline">Escribir un desacuerdo</span>
      </v-card-title>

      <v-card-text>
        <!-- Text area -->
        <v-textarea
          v-model="content"
          label="Contenido"
          auto-grow
          rows="10"
          outlined
          ref="textarea"
          
        ></v-textarea>
      </v-card-text>

      <!-- Acciones de la tarjeta -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="saveContent">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Element from '@/models/Element';
import api from '@/api.js';

export default {
  name: "CreateDisagreement",
  props: {
    value: Boolean,  // Controla la visibilidad
    fromElementId: {
      type: String,
      default: null,
    },
    users: {
      type: Array,
      default: () => [],
    },
    topic: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", val);
      },
    },
    updatedElement() {
      const output = { ...this.element, description: this.content, blocked: false };
      return output;
    },
    userId(){
      const output = this.$store.state.user._id;
      return output;
    },
    meetingId(){
      const output = this.$store.state.meeting._id;
      return output;
    },
    projectId(){
      const output = this.$store.state.project._id;
      return output;
    },
    meetingMinuteId(){
      const output = this.$store.state.meetingMinute._id;
      return output;
    },
  },
  data() {
    return {
      content: "",
    };
  },
  watch: {
  },
  methods: {
    // Method that send the element to the server
    async sendDisagreement(){
      try{
        const element = new Element({
          description: this.content,
          disagreementFrom: this.fromElementId,
          writer: this.userId || null,
          project: this.projectId,
          meeting: this.meetingId,
          meetingminute: this.meetingMinuteId,
          type: 'desacuerdo',
          blocked: false,
          topic: this.topic,
        });

        const response = await api.post('/api/element', element);
        if(response.status === 200 || response.status === 201){
          this.$emit('update:topic', null);
          this.$socket.emit('event_add_element', {
          room: this.meetingId,
          user: localStorage.getItem('email'),
          element: response.data
        });
        }else{
          console.error('Error al enviar el desacuerdo:', response);
        }
      }catch(e){
        console.error('Error al enviar el desacuerdo:', e);
      }
    },
    saveContent() {
      this.sendDisagreement();
      this.$emit("cancelDisagreement");
    },
    cancel() {
      this.$emit("cancelDisagreement");
    },
  },
  mounted() {
    // Hacer focus en el textarea al abrir el diálogo
    this.$nextTick(() => {
      this.$refs.textarea.focus();
    });
  },
};
</script>
